import cn from 'classnames'
import { memo, useMemo } from 'react'

import { PartnerFlagRequestAction } from 'clickNgo/configs/profiling/partnerFlag'
import { Translation } from 'cng-common/features/translations/components/translation'
import { getFormatDate } from 'core/classes/helpers/DateHelper'
import { List } from 'shared/components/list'

import { partnerFlagsTranslation } from '../../../../translation'

import { ACTION_REPLACED_PARAM, STATUS_REPLACED_PARAM } from './configs'
import { IPartnerFlagCoverProps } from './models'

import styles from './PartnerFlagCover.module.scss'

export const PartnerFlagCover = memo<IPartnerFlagCoverProps>(({ partnerFlag }) => {
  // NewEffectiveDate holds the new start date of a reactivated flag (set by
  // CnGTriggerPartnerFlagChange), so the expiry must always come from endDate
  const expiry = useMemo(() => getFormatDate(partnerFlag.endDate, 'date'), [partnerFlag.endDate])

  const badgeActionColorStyle = useMemo(() => {
    switch (partnerFlag.action) {
      case PartnerFlagRequestAction.Add:
        return styles.badgeAdd
      case PartnerFlagRequestAction.Remove:
        return styles.badgeRemove
      case PartnerFlagRequestAction.Modify:
        return styles.badgeModify
      default:
        return ''
    }
  }, [partnerFlag.action])

  return (
    <List.Label className={styles.cover}>
      <div className={styles.leftSide}>
        <div className={styles.code}>{partnerFlag.code || '-'}</div>
        <div className={styles.codeName}>{partnerFlag.codeName || partnerFlag.code || '-'}</div>
      </div>
      <div className={styles.rightSide}>
        <div
          className={cn(styles.badge, {
            [styles.hidden]: !partnerFlag.status,
          })}
        >
          <div className={cn(styles.badgeStatus)}>
            <Translation
              text={partnerFlagsTranslation.cover.status}
              span
              replaceParams={[{ key: STATUS_REPLACED_PARAM, value: partnerFlag.status || '-' }]}
            />
          </div>
          <div className={cn(styles.badgeAction, badgeActionColorStyle)}>
            <Translation
              text={partnerFlagsTranslation.cover.action}
              span
              replaceParams={[{ key: ACTION_REPLACED_PARAM, value: partnerFlag.action || '-' }]}
            />
          </div>
        </div>
        <div className={cn(styles.expiry)}>
          <div className={styles.expiry_label}>
            <Translation text={partnerFlagsTranslation.cover.expiry} span />
          </div>
          <div className={styles.expiry_field}>{expiry}</div>
        </div>
      </div>
    </List.Label>
  )
})
